export enum UrlAliasType {
  Product = 'Product',
  Brand = 'Brand',
  Category = 'Category',
  Shop = 'Shop',
  Tag = 'Tag',
  Cms = 'Cms',
}

export class UrlAlias {
  type!: UrlAliasType;
  entityId!: number;
  alias!: string;
}
